
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modern-chatgpt-ui-for-power-users",
      function () {
        return require("private-next-pages/modern-chatgpt-ui-for-power-users.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modern-chatgpt-ui-for-power-users"])
      });
    }
  